import {
  getAutoCroppedImages,
  constants,
} from '@bingads-webui-campaign-react/image-experience';

import { IMTAsset, IImageMapUrl } from './types';

export function getPortraitExperience(assets: IMTAsset[], imageToUrlMap: IImageMapUrl) {
  const portraitGroup = Object.keys(imageToUrlMap);

  // ImageToUrlMap contains distinct ids, while assets could contain multiple assets with same id
  return assets.filter(ass => portraitGroup.includes(ass.IdString)).map((asset) => {
    const key = asset.IdString;
    const assetExtraInfo = imageToUrlMap[key];

    return getAutoCroppedImages({
      originalImageToCrop: {
        Id: key,
        IdString: key,
        Src: imageToUrlMap[key].url,
        Width: imageToUrlMap[key].width,
        Height: imageToUrlMap[key].height,
        source: imageToUrlMap[key].sourceType,
      },
      imageOption: constants.imageOptionKeys.Portrait,
      aspectRatioOption: constants.portraitSubtypes[asset.SubType],
      isMultimediaAdinMSANEnabled: true,
      isPortraitImage: true,
      maxCropBox: {
        SourceX: asset.CropX ? asset.CropX : 0,
        SourceY: asset.CropY ? asset.CropY : 0,
        SourceWidth: asset.CropWidth ? asset.CropWidth : assetExtraInfo.width,
        SourceHeight: asset.CropHeight ? asset.CropHeight : assetExtraInfo.height,
      },
    });
  });
}
